import { reject, sumBy } from 'lodash';
import { createSelector } from 'reselect';

export const getCountries = (state) => {
  const entities = Object.values(state?.countries || {});
  const australia = entities.find((country) => country.name === 'AUSTRALIA');
  const orderedCountries = reject(entities, { name: 'AUSTRALIA' });

  // Make Australia the first option
  if (australia) {
    orderedCountries.unshift(australia);
  }

  return orderedCountries.map((country) => {
    // NEW ZEALAND -> New Zealand
    const countryName = country.name?.toLowerCase() || '';
    const name = countryName.replace(/^[a-zå]|\([a-z]|\s[a-z]|\.[a-z]/gi, (x) =>
      x.toUpperCase()
    );

    return {
      ...country,
      name,
    };
  });
};

export const getAuCountryId = (state) => {
  const entities = Object.values(state?.countries || {});

  return entities.find(({ name }) => name === 'AUSTRALIA')?.id;
};

export const getCountryCodeById = createSelector(
  [(state) => Object.values(state?.countries || {}), (_, params) => params],
  (countries, params) => {
    const { countryId } = params;
    const country = countries.find(({ id }) => id === countryId);
    return country?.iso_3166_code;
  }
);

export const getPendingGiftCards = (state) => {
  const { pendingGiftCards } = state.giftCard;
  const result = [];

  pendingGiftCards.forEach((card) => {
    const existingRecord = result.find(
      (item) => item.cardNumber === card.cardNumber
    );

    if (existingRecord) {
      existingRecord.amount += card.amount;
    } else {
      result.push({
        ...card,
      });
    }
  });

  return result;
};

export const getTotalGiftCardAmount = (state) => {
  const { pendingGiftCards } = state.giftCard;

  return sumBy(pendingGiftCards, 'amount');
};

export const getDefaultSavedCreditCard = (state) => {
  const { savedCards } = state.checkout;

  return savedCards?.find((card) => card.default);
};
